// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2AD4a","image":"Header_image__2hG-4","name":"Header_name__1f_Nh","info":"Header_info__14G8_","infoRow":"Header_infoRow__22JL6"};